/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import {useParams} from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC, API_SERVER } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode, encode} from 'html-entities';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { capitalizeFirstLetter} from '../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Style]
-------------------------------------------------------------------*/
import '../../style/general/node.entry.css';
/*------------------------------------------------------------------
[End Style]
-------------------------------------------------------------------*/


const Screen = ({loading, error}) => {
    
    const { slug } = useParams();
    
	const [data, set_data] = useState(null);

    const _read = () => {

		loading(true);

		API_GET_PUBLIC('client/pages__________?slug=' + slug)
        .then((response) => {
			if(response.data.result === 'success'){
                loading(false)
                set_data(response.data.data[0])
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
			console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
			loading(false)
		})

    }
    
    useEffect(() => {
        
		_read()

    }, [slug])

    const createMarkup = () => {
        return {__html: JSON.parse(decode(data.entry))}
    }

    return (
        <>
            {data &&
            
                <Helmet>

                    <meta name="description" content={decode(data.description)}/>
                    <title>{decode(data.title)}</title>

                    {/* Essential META Tags */}
                    <meta property="og:type" content="pages"/>
                    <meta property="og:title" content={decode(data.title)}/>
                    <meta property="og:description" content={decode(data.description)}/>
                    <meta property="og:image" itemprop="image" content={decode(data.preview)}/>
                    <meta property="og:url" content={window.location.href}/>
                    <meta name="twitter:card" content="summary_large_image"/>
                    {/* Non-Essential, But Recommended */}
                    <meta property="og:site_name" content={decode(data.title)}/>
                    <meta name="twitter:image:alt" content={decode(data.preview)}/>

                </Helmet>
            }

            <div className="_container" style={{maxWidth: 800}}>
                <div className="_lily_pad_h_d __section_pages_title">
                    {data&&
                        <>
                            <p className="_push_b_s">{decode(data.level.toUpperCase())}</p>
                            <h1>{decode(data.title)}</h1>
                        </>
                    }
                </div>
            </div>
            {data?
                <img src={data.preview} alt={decode(data.title)}/>
                : 
                <div className="__pages_image"></div>
            }
            {data&&

                <div className="_container" style={{maxWidth: 800}}>
                    <div className="_push_t_g">
                        <div className="_push_t_s _push_b_d _lily_pad_h_d">
                            <b className="_font_size_16px">{capitalizeFirstLetter(data.author)}</b>
                            <p className="_push_t_s">Published {data.date}</p>
                        </div>
                        <div className="_lily_pad_h_d">
                            <div className="__entry" dangerouslySetInnerHTML={createMarkup()}></div>
                        </div>
                        {/* <div className="_column_auto _push_t_s">
                            <div className="__pages_sosmed">
                                <a href={'https://facebook.com/flamecore'}>
                                    <ion-icon name="logo-facebook"></ion-icon>
                                </a>
                                <a href={'https://instagram.com/flamecore'}>
                                    <ion-icon name="logo-instagram"></ion-icon>
                                </a>
                                <a href={'https://twitter.com/flamecore'}>
                                    <ion-icon name="logo-twitter"></ion-icon>
                                </a>
                                <a href={'https://youtube.com/'}>
                                    <ion-icon name="logo-youtube"></ion-icon>
                                </a>
                            </div>
                        </div> */}
                    </div>
                </div>
            
            }
        </>
    );

}

export default Screen;